import React from 'react';
import { Link } from 'react-router-dom';
import InfoMessage from 'ui/views/messages/InfoMessage';
import MoneyBagIcon from 'ui/elements/icons/MoneyBagIcon';
import styled from '@emotion/styled';
import { quarterSpacing } from 'ui/theme/themeConstants';
import { bluePlanetTheme } from 'ui/theme';

const RaisCapitalHeadline = styled.span`
  ${bluePlanetTheme.breakpoints.down('sm')} {
    display: block;
    margin-bottom: ${quarterSpacing};
  }
`;

interface Props {
  isMobile: boolean;
  onClose: () => void;
}

export default function RaisingCapitalMessage({ isMobile, onClose }: Props) {
  const currentYear = new Date().getFullYear();

  return (
    <InfoMessage color="green" icon={isMobile ? undefined : <MoneyBagIcon />} onClose={onClose}>
      <RaisCapitalHeadline className="text-weight-bold">
        Planning to raise capital in {currentYear}?
      </RaisCapitalHeadline>{' '}
      <Link to="/communities/investor-matching/" className="text-link-underlined text-link-green-dark">
        Click to get a quote on investor matching
      </Link>{' '}
      and boost your network in a few quick steps.
    </InfoMessage>
  );
}
